module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReturnsLoaded) ? _c('div', [(_vm.visibleRequests.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "red"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 pull-right"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("An amendment has been requested for this Return\n                        "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.returnsAmendBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.returnsAmendBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.returnsAmendBody
    }
  }, _vm._l((_vm.visibleRequests), function(a, a_idx) {
    return _c('div', {
      key: ("ret_amend_" + a_idx)
    }, [(a.text) ? _c('p', [_c('b', [_vm._v("Details:")])]) : _vm._e(), _vm._l((_vm.splitText(a.text)), function(t, t_idx) {
      return _c('div', {
        key: ("ret_text_" + t_idx)
      }, [_vm._v(_vm._s(t)), _c('br')])
    }), _vm._v(" "), _c('p')], 2)
  }), 0)])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b367b3a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/return_amendment.vue
// module id = 1041
// module chunks = 0